// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2XqE6","title":"BackImages_title__1G12U","images":"BackImages_images__2YNOA"};